import { render } from "./areaTree.vue?vue&type=template&id=4e5ffd92&scoped=true"
import script from "./areaTree.vue?vue&type=script&lang=js"
export * from "./areaTree.vue?vue&type=script&lang=js"

import "./areaTree.vue?vue&type=style&index=0&id=4e5ffd92&scoped=true&lang=css"

import exportComponent from "D:\\_2021\\项目管理系统\\TYH_office_automation\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e5ffd92"]])

export default __exports__